import { WEBHOOK_URL } from '../constants/config';

export const submitRSVP = async (formData, foodPreferences) => {
    const dataToSend = {
        name: formData.name,
        numberOfGuests: parseInt(formData.numberOfGuests),
        foodPreferences: foodPreferences,
        additionalInfo: formData.additionalInfo,
        submittedAt: new Date().toISOString()
    };

    try {
        const response = await fetch(WEBHOOK_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        });

        if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status}`);
        }

        const result = await response.json();
        return { success: true, data: result };
    } catch (error) {
        console.error('Error sending to n8n:', error);
        return {
            success: false,
            error: error.message || 'Fehler beim Senden der RSVP. Bitte versuchen Sie es erneut.'
        };
    }
};